<template>
  <div class="c-google-map"></div>
</template>

<script>
export default {

  data (){
    return {
      apiKey: "AIzaSyA5FaieFr8Q16r4Ke9ajbn-U8U5BvXyuDk",
      apiUrl: "https://maps.googleapis.com/maps/api/js?key=%s&callback=__initMap",
      center: {
        lat: 28.3771232,
        lng: 129.4928687
      }
    };
  },

  mounted (){
    window.__initMap = this.initMap;

    let el = document.createElement("script");
    el.src = this.apiUrl.replace(/%s/, this.apiKey);
    document.querySelector("body").appendChild(el);


  },

  methods: {
    initMap (){
      const map = new google.maps.Map(
        // document.querySelector(".c-google-map"),
        this.$el,
        {
          center: this.center,
          zoom: 12
        }
      );
      const marker = new google.maps.Marker({
        position: this.center,
        map: map,
        icon: "/assets/img/common/map-pin.svg"
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/google-map.vue